import React from 'react';
import isHoverable from '../utility/isHoverable';

export const Help = isHoverable((props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="14"
    viewBox="0 0 9 14"
  >
    <path
      d="M3.875 13.75H6.125V11.5H3.875V13.75ZM5 0.25C2.51375 0.25 0.5 2.26375 0.5 4.75H2.75C2.75 3.5125 3.7625 2.5 5 2.5C6.2375 2.5 7.25 3.5125 7.25 4.75C7.25 7 3.875 6.71875 3.875 10.375H6.125C6.125 7.84375 9.5 7.5625 9.5 4.75C9.5 2.26375 7.48625 0.25 5 0.25Z"
      fill="#151515"
    />
  </svg>
));

export const Accessibility = isHoverable((props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 1 16 16"
    width="15"
    height="15"
  >
    <path
      d="M13.5726 8.735C13.6026 8.495 13.6251 8.255 13.6251 8C13.6251 7.745 13.6026 7.505 13.5726 7.265L15.1551 6.0275C15.2976 5.915 15.3351 5.7125 15.2451 5.5475L13.7451 2.9525C13.6551 2.7875 13.4526 2.7275 13.2876 2.7875L11.4201 3.5375C11.0301 3.2375 10.6101 2.99 10.1526 2.8025L9.86762 0.815C9.84512 0.635 9.68762 0.5 9.50012 0.5H6.50012C6.31262 0.5 6.15512 0.635 6.13262 0.815L5.84762 2.8025C5.39012 2.99 4.97012 3.245 4.58012 3.5375L2.71262 2.7875C2.54012 2.72 2.34512 2.7875 2.25512 2.9525L0.755124 5.5475C0.657624 5.7125 0.702624 5.915 0.845124 6.0275L2.42762 7.265C2.39762 7.505 2.37512 7.7525 2.37512 8C2.37512 8.2475 2.39762 8.495 2.42762 8.735L0.845124 9.9725C0.702624 10.085 0.665124 10.2875 0.755124 10.4525L2.25512 13.0475C2.34512 13.2125 2.54762 13.2725 2.71262 13.2125L4.58012 12.4625C4.97012 12.7625 5.39012 13.01 5.84762 13.1975L6.13262 15.185C6.15512 15.365 6.31262 15.5 6.50012 15.5H9.50012C9.68762 15.5 9.84512 15.365 9.86762 15.185L10.1526 13.1975C10.6101 13.01 11.0301 12.755 11.4201 12.4625L13.2876 13.2125C13.4601 13.28 13.6551 13.2125 13.7451 13.0475L15.2451 10.4525C15.3351 10.2875 15.2976 10.085 15.1551 9.9725L13.5726 8.735ZM8.00012 10.625C6.55262 10.625 5.37512 9.4475 5.37512 8C5.37512 6.5525 6.55262 5.375 8.00012 5.375C9.44762 5.375 10.6251 6.5525 10.6251 8C10.6251 9.4475 9.44762 10.625 8.00012 10.625Z"
      fill="#151515"
    />
  </svg>
));

export const Annotations = isHoverable(({ isMobile, ...props }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width={isMobile ? '13' : '14'}
    height={isMobile ? '13' : '14'}
    viewBox="0 0 14 14"
  >
    <path
      d="M0.25 11.0949V13.3749C0.25 13.5849 0.415 13.7499 0.625 13.7499H2.905C3.0025 13.7499 3.1 13.7124 3.1675 13.6374L11.3575 5.45492L8.545 2.64242L0.3625 10.8249C0.2875 10.8999 0.25 10.9899 0.25 11.0949ZM13.5325 3.27992C13.825 2.98742 13.825 2.51492 13.5325 2.22242L11.7775 0.467422C11.485 0.174922 11.0125 0.174922 10.72 0.467422L9.3475 1.83992L12.16 4.65242L13.5325 3.27992Z"
      fill="#151515"
    />
  </svg>
));

export const Calculator = isHoverable(({ color, isMobile, ...props }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width={isMobile ? '17' : '16'}
    height={isMobile ? '22' : '20'}
    viewBox="0 0 16 20"
  >
    <path
      fill={color}
      fillRule="nonzero"
      d="M14 0H2C.895 0 0 .84 0 1.875v16.25C0 19.161.895 20 2 20h12c1.105 0 2-.84 2-1.875V1.875C16 .839 15.105 0 14 0zM2 1.25h12c.368 0 .667.28.667.625V5H1.333V1.875c0-.345.3-.625.667-.625zm12 17.5H2c-.368 0-.667-.28-.667-.625V6.25h13.334v11.875c0 .345-.3.625-.667.625zM5.333 7.969V9.53c0 .26-.224.469-.5.469H3.167c-.276 0-.5-.21-.5-.469V7.97c0-.26.224-.469.5-.469h1.666c.276 0 .5.21.5.469zm4 0V9.53c0 .26-.224.469-.5.469H7.167c-.276 0-.5-.21-.5-.469V7.97c0-.26.224-.469.5-.469h1.666c.276 0 .5.21.5.469zm4 0V9.53c0 .26-.224.469-.5.469h-1.666c-.276 0-.5-.21-.5-.469V7.97c0-.26.224-.469.5-.469h1.666c.276 0 .5.21.5.469zm-8 3.75v1.562c0 .26-.224.469-.5.469H3.167c-.276 0-.5-.21-.5-.469V11.72c0-.26.224-.469.5-.469h1.666c.276 0 .5.21.5.469zm4 0v1.562c0 .26-.224.469-.5.469H7.167c-.276 0-.5-.21-.5-.469V11.72c0-.26.224-.469.5-.469h1.666c.276 0 .5.21.5.469zm4 0v5.312c0 .26-.224.469-.5.469h-1.666c-.276 0-.5-.21-.5-.469V11.72c0-.26.224-.469.5-.469h1.666c.276 0 .5.21.5.469zm-8 3.75v1.562c0 .26-.224.469-.5.469H3.167c-.276 0-.5-.21-.5-.469V15.47c0-.26.224-.469.5-.469h1.666c.276 0 .5.21.5.469zm4 0v1.562c0 .26-.224.469-.5.469H7.167c-.276 0-.5-.21-.5-.469V15.47c0-.26.224-.469.5-.469h1.666c.276 0 .5.21.5.469z"
    />
  </svg>
));

export const FormulaSheet = isHoverable(({ isMobile, ...props }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width={isMobile ? '17' : '21'}
    height={isMobile ? '22' : '21'}
    viewBox="0 0 21 21"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-961.000000, -203.000000)"
        fill="#1E1E1E"
        fillRule="nonzero"
      >
        <path
          d="M962.191304,218.989162 C962.969552,218.99947 963.599624,218.764965 964.081519,218.285647 C964.563415,217.806328 964.855902,217.136314 964.958981,216.275602 L964.958981,216.275602 L966.172739,208.328195 L967.688003,208.328195 L967.865815,207.22267 L966.34282,207.22267 L966.443322,206.457307 C966.592787,205.318282 967.131375,204.748769 968.059088,204.748769 C968.265247,204.748769 968.51006,204.779693 968.793528,204.841541 L968.793528,204.841541 L969.017725,203.68963 C968.543561,203.581397 968.175053,203.527281 967.912201,203.527281 C967.128799,203.516973 966.481976,203.759209 965.971734,204.253989 C965.461492,204.748769 965.152255,205.447131 965.044021,206.349074 L965.044021,206.349074 L964.935788,207.22267 L963.652452,207.22267 L963.482371,208.328195 L964.765708,208.328195 L963.55195,216.229216 C963.387023,217.290932 962.95409,217.82179 962.253152,217.82179 C962.036685,217.82179 961.791872,217.780559 961.518712,217.698095 L961.518712,217.698095 L961.302246,218.826813 C961.621792,218.924738 961.918144,218.978854 962.191304,218.989162 Z M970.629423,218.179448 L970.988301,217.319279 C970.255354,216.711654 969.898374,215.627424 969.917362,214.066587 C969.924958,213.474153 969.987619,212.805766 970.105346,212.061426 C970.450933,209.866381 971.273125,208.273265 972.571923,207.282077 L972.571923,207.282077 L972.298492,206.364943 C971.349078,206.786483 970.560116,207.531772 969.931604,208.600812 C969.303092,209.669852 968.897692,210.882254 968.715405,212.238017 L968.715405,212.238017 L968.692619,212.374732 C968.650844,212.697533 968.62616,213.039322 968.618564,213.400099 C968.595778,214.258369 968.692619,215.063472 968.909085,215.815408 C969.235683,216.935716 969.809129,217.723729 970.629423,218.179448 L970.629423,218.179448 Z M973.397913,215.587548 L974.759373,213.662137 L975.517005,215.587548 L977.146199,215.587548 L975.898669,212.522841 L978.131691,209.423954 L976.325906,209.423954 L975.032804,211.252525 L974.34353,209.423954 L972.714335,209.423954 L973.9049,212.363339 L971.580735,215.587548 L973.397913,215.587548 Z M977.544953,218.196537 C978.236126,217.904118 978.857992,217.419917 979.410551,216.743934 C979.96311,216.067952 980.410284,215.231518 980.752073,214.234634 C981.093862,213.237749 981.276149,212.211433 981.298935,211.155685 C981.30653,210.460714 981.233425,209.784731 981.07962,209.127737 C980.925815,208.470743 980.688462,207.909639 980.36756,207.444426 C980.046658,206.979214 979.662146,206.625082 979.214022,206.382032 L979.214022,206.382032 L978.855144,207.242201 C979.580496,207.853624 979.933678,208.939753 979.91469,210.500589 C979.907094,211.100619 979.848231,211.755714 979.738099,212.465876 C979.39631,214.679909 978.574117,216.290115 977.271522,217.296493 L977.271522,217.296493 L977.544953,218.196537 Z"
          id="ƒ(x)"
        />
      </g>
    </g>
  </svg>
));

export const PeriodicTable = isHoverable(({ isMobile, ...props }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width={isMobile ? '17' : '21'}
    height={isMobile ? '22' : '20'}
    viewBox="0 0 21 21"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-961.000000, -234.000000)">
        <g transform="translate(961.000000, 234.000000)">
          <rect stroke="#1E1E1E" x="0.5" y="0.5" width="19" height="19" />
          <polygon
            id="H"
            fill="#1D2225"
            fillRule="nonzero"
            points="8.44230769 16 8.44230769 13 11.2548077 13 11.2548077 16 12.6971154 16 12.6971154 9 11.2548077 9 11.2548077 11.8365385 8.44230769 11.8365385 8.44230769 9 7 9 7 16"
          />
          <polygon
            id="1"
            fill="#1D2225"
            fillRule="nonzero"
            points="10.6731234 6.847656 10.6731234 3 10.5913145 3 9 3.57002311 9 4.19018714 9.91045358 3.90781458 9.91045358 6.847656"
          />
        </g>
      </g>
    </g>
  </svg>
));

export const Submit = isHoverable(({ color, ...props }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path
      fill={color}
      fillRule="nonzero"
      d="M15.139 14.4v3.66c0 1.028-.842 1.863-1.879 1.863H1.879A1.872 1.872 0 0 1 0 18.06V1.903C0 .873.842.039 1.879.035h8.097c.497 0 .975.198 1.327.548l3.284 3.258c.352.35.552.827.552 1.32V8.64h-1.572V6.573h-4.07a.934.934 0 0 1-.94-.932V1.6h-6.36a.626.626 0 0 0-.626.622v15.516c0 .342.282.622.627.622H12.95c.344 0 .617-.28.617-.622V14.4h1.572zm-1.915-9.677l-2.806-2.779a.617.617 0 0 0-.29-.163V5.01h3.26a.61.61 0 0 0-.164-.287zm6.672 6.54a.37.37 0 0 1 0 .514l-3.4 3.476a.349.349 0 0 1-.501 0l-.204-.208a.367.367 0 0 1 .006-.517l2.528-2.494H8.876a.36.36 0 0 1-.354-.363v-.302c0-.2.16-.363.354-.363h9.446l-2.528-2.494a.37.37 0 0 1-.006-.517l.204-.208a.352.352 0 0 1 .505 0l3.399 3.476z"
    />
  </svg>
));
